import React from 'react';
import Badge from 'react-bootstrap/Badge';
import { toast } from 'react-toastify';
import { TransportOrderFeedStatus } from '../../domain/transportOrdersFeed';
import {
    useChangeTransportOrderStatusRepository,
} from '../../repository/transport-orders/useChangeTransportOrderStatusRepository';
import { statuses } from './statuses.const';

type TransportOrderFeedStatusBadgeProps = {
    transportOrderId: string;
    status: TransportOrderFeedStatus;
}

export const TransportOrderFeedStatusBadge = ({ transportOrderId, status }: TransportOrderFeedStatusBadgeProps) => {
    const { changeTransportOrderStatus } = useChangeTransportOrderStatusRepository();

    const { label, variant, updateToStatus } = statuses[status];

    const handleStatusChangeClick = async () => {
        if (!updateToStatus) {
            return;
        }

        await changeTransportOrderStatus({ transportOrderId: transportOrderId, newStatus: updateToStatus.status });

        toast.success('Pomyślnie potwierdzono zlecenie');
    };

    return <Badge
        className={`${variant === 'warning' ? 'text-black' : ''} ${updateToStatus && 'fw-bold cursor-pointer py-2'}`}
        onClick={handleStatusChangeClick}
        bg={variant}
    >
        <span className="text-truncate">{label}</span>
    </Badge>;
};